import { useCurrentBoardBackground } from './useBoardBackground';
import { useDynamicTokens } from './useDynamicTokens';

/**
 * Helper function for assigning dynamic tokens for the current board background
 * to a given element.
 */
export function useDynamicBoardTokens(
  props: Omit<Parameters<typeof useDynamicTokens>[0], 'background'>,
) {
  const {
    backgroundBrightness,
    backgroundColor,
    backgroundTopColor,
    isBackgroundImage,
  } = useCurrentBoardBackground();

  useDynamicTokens({
    ...props,
    background: {
      backgroundBrightness,
      backgroundColor: isBackgroundImage ? backgroundTopColor : backgroundColor,
      isBackgroundImage,
    },
  });
}
